module.exports = __webpack_public_path__ + "img/imgl1.62d5b3ae.png";